<template>
  <div class="team-board">
    <h4 class="team-title">チーム掲示板</h4>
    <div class="mb-2 mt-2">
      <v-dialog
        v-model="dialog"
        persistent
        max-width="600px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            depressed
            :disabled="listTeamUser.length < 2"
            v-bind="attrs"
            v-on="on"
          >
            新規投稿
          </v-btn>
        </template>
        <v-form @submit.prevent ref="post_comment_form">
          <v-card class="postCommentForm overflow-y-auto mx-auto">
            <v-card-text>
              <v-switch
                v-model="isStampMessageWindow"
                :label="`${isStampMessageWindow ? 'スタンプメッセージ' : '励ましメッセージ'}`"
                inset
              />
              <v-container>
                <v-row v-if="!isStampMessageWindow">
                  <!-- 励ましメッセージ画面 -->
                  <v-col cols="12">
                    <v-select
                      v-model="post.comment"
                      :items="listTeamUserWithoutCurrentUser"
                      label="励ます人を選択してください"
                      item-text="name"
                    >
                      <template v-slot:item="slotProps">
                        <i :class="['mr-2', 'em', slotProps.item.image_id]"></i>
                        {{slotProps.item.name}}
                      </template>
                    </v-select>
                  </v-col>
                </v-row>

                <!-- スタンプメッセージ画面 -->
                <v-row
                  v-if="isStampMessageWindow"
                  class="stampRadios overflow-y-auto mx-auto"
                >
                  <v-col cols="12">
                    <div v-for="image in listTeamBoardImage" :key="image.id" class="stampRadio">
                      <label>
                        <input type="radio" :value="image.filename" v-model="post.image_id">
                        <img :src="`/image/board_stamp/${image.filename}`" />
                      </label>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
              <v-card-actions>
              <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  :loading="isPostLoading"
                  :disabled="isDisabledPostTeamComment"
                  @click="postTeamComment"
                >
                  投稿
                </v-btn>
                <v-btn
                  :loading="isPostLoading"
                  @click="dialog = false"
                >
                  キャンセル
                </v-btn>
            </v-card-actions>
            </v-card-text>
          </v-card>
        </v-form>
      </v-dialog>
    </div>
    <!-- 初期表示での投稿データ取得時のローディング -->
    <div class="text-center">
      <v-progress-circular indeterminate color="secondary" v-if="isInitLoading" />
    </div>
    <!-- チームメンバーが1名のみ場合のメッセージ -->
    <v-alert
      border="left"
      colored-border
      type="warning"
      elevation="2"
      style="font-size: 90%"
      v-if="listTeamUser.length < 2"
    >
      新規投稿は、2人以上のチームでご利用いただけます。
    </v-alert>
    <!-- 投稿データが無い場合のメッセージ -->
    <v-alert
      border="left"
      colored-border
      type="info"
      elevation="2"
      style="font-size: 90%"
      v-else-if="!isInitLoading && listTeamBoard.length === 0"
    >
      投稿がまだありません。
    </v-alert>

    <!-- チーム掲示板 -->
    <v-data-iterator
      class="timeline"
      :items="listTeamBoard"
      item-key="id"
      v-if="listTeamBoard.length > 0"
      hide-default-footer
      disable-pagination
    >
      <template v-slot:default="{ items }">
        <v-row>
          <v-col
            v-for="item in items"
            :key="item.id"
            cols="12"
          >
            <div
              class="boardThread"
              :class="item.username === campaignUser.id ? 'my' : 'other'"
            >
              <div class="avatar">
                <v-avatar
                  :color="randomColor(item.username)"
                  :title="item.name"
                >
                  <span class="white--text">
                    {{item.name | truncate }}
                  </span>
                </v-avatar>
              </div>
              <span class="avatarUserName">
                {{ item.name }}
              </span>
              <span class="timeAndDeleteBtn">
                {{ item.created_at | formatDate }}
                <v-btn
                  color="grey"
                  small
                  icon
                  :loading="isDeleteLoading"
                  :disabled="isDeleteLoading"
                  @click="deleteTeamComment(item)"
                  v-if="user.username === item.username"
                >
                  <v-icon>
                    mdi-delete
                  </v-icon>
                </v-btn>
              </span>
              <div>
                <p
                  class="boardComment"
                  v-if="item.post_type === 'comment'"
                >
                  {{ item.comment }}
                </p>
                <img
                  class="boardImage"
                  v-bind:src="`/image/board_stamp/${item.image_id}`"
                  contain
                  v-else-if="item.post_type === 'image'"
                />
              </div>
            </div>
          </v-col>
        </v-row>
        <!-- スクロールでの投稿データ取得時のローディング -->
        <div class="text-center">
          <v-progress-circular indeterminate color="secondary" v-if="isGetLoading" />
        </div>
      </template>
    </v-data-iterator>
    <!-- 画面TOPに戻るボタン -->
    <div>
      <v-btn
        class="topButton"
        elevation="5"
        large
        icon
        v-if="isDispTopButton"
        @click="returnTop"
      >
        <v-icon dark>
          mdi-arrow-up
        </v-icon>
      </v-btn>
    </div>
    <Dialog ref="confirm"/>
  </div>
</template>

<script>
import { Auth } from 'aws-amplify'
import GraphqlAPI from '../../utils/GraphqlAPI'
import dayjs from 'dayjs'
const Dialog = () => import('../util/Dialog.vue')

// 投稿取得クエリ（next_token無し）
const listTeamBoardQuery = (campaignId, teamId, limit) => `
  query listTeamBoardQuery {
    listTeamBoard(
      campaign_id: "${campaignId}",
      team_id: "${teamId}",
      limit: ${limit}
    ) {
      team_boards {
        id
        team_id
        username
        name
        post_type
        comment
        image_id
        created_at
      }
      next_token
    }
  }
`
// 投稿取得クエリ（next_tokenあり）
const listTeamBoardQueryWithToken = (campaignId, teamId, limit, token) => `
  query listTeamBoardQuery {
    listTeamBoard(
      campaign_id: "${campaignId}",
      team_id: "${teamId}",
      limit: ${limit},
      next_token: "${token}"
      ) {
      team_boards {
        id
        username
        name
        post_type
        comment
        image_id
        created_at
      }
      next_token
    }
  }
`
const getListTeamBoard = async (campaignId, teamId, limit, token) => {
  const { data: { listTeamBoard: data } } =
    token
      ? await GraphqlAPI(listTeamBoardQueryWithToken(campaignId, teamId, limit, token))
      : await GraphqlAPI(listTeamBoardQuery(campaignId, teamId, limit))
  return {
    listTeamBoard: data.team_boards.map((item) => {
      return {
        id: item.id,
        username: item.username,
        name: item.name,
        post_type: item.post_type,
        comment: item.comment,
        image_id: item.image_id,
        created_at: item.created_at
      }
    }),
    next_token: data.next_token
  }
}
// スタンプマスタ取得クエリ
const listTeamBoardImageQuery = (campaignId) => `
  query listTeamBoardImageQuery {
    listTeamBoardImage(
      campaign_id: "${campaignId}"
      ) {
      team_board_images {
        id
        filename
      }
    }
  }
`
const getlistTeamBoardImage = async (campaignId) => {
  const { data: { listTeamBoardImage: data } } = await GraphqlAPI(listTeamBoardImageQuery(campaignId))
  return data.team_board_images
}
// 新規投稿クエリ
const postTeamCommentMutation = (campaignId, teamId, post) => `
  mutation postTeamCommentMutation {
    postTeamComment(
      campaign_id: "${campaignId}",
      input: {
        team_id: "${teamId}",
        post_type: "${post.post_type}",
        ${post.post_type === 'comment' ? 'comment' : 'image_id'}:  "${post.post_type === 'comment' ? post.comment : post.image_id}"
      }
    ) {
      id
    }
  }
`
const putPostTeamComment = async (campaignId, teamId, post) => {
  const { data: { postTeamComment: data } } = await GraphqlAPI(postTeamCommentMutation(campaignId, teamId, post))
  return {
    post: data
  }
}
// 投稿削除クエリ
const deleteTeamCommentMutation = (campaignId, teamId, post) => `
  mutation deleteTeamCommentMutation {
    deleteTeamComment(
      campaign_id: "${campaignId}",
      team_id: "${teamId}",
      comment_id: "${post.id}"
    ) {
      id
    }
  }
`
const putDeleteTeamComment = async (campaignId, teamId, post) => {
  const { data: { deleteTeamComment: data } } = await GraphqlAPI(deleteTeamCommentMutation(campaignId, teamId, post))
  return {
    post: data
  }
}

export default {
  name: 'team_board',
  components: {
    Dialog
  },
  props: [
    'campaignUser',
    'listTeamUser',
    'teamId'
  ],
  data () {
    return {
      user: {
        username: null,
        identityId: '' // amplify S3でprotectedとして格納するため利用
      },
      dialog: false, // 新規投稿ダイアログ表示フラグ
      isStampMessageWindow: false, // 新規投稿画面内の切り替えフラグ
      isDispTopButton: false, // TOPに戻るボタン表示フラグ
      isPostLoading: false, // 新規投稿用
      isDeleteLoading: false, // 投稿削除用
      isInitLoading: false, // 初期表示でのリスト取得用
      isGetLoading: false, // スクロールでのリスト取得用
      post: {},
      next_token: '', // 次の件数を取得するためのトークン
      maxListTeamBoardSize: 10, // 1度に取得するチーム掲示板投稿件数
      listTeamBoard: [], // 取得した全投稿
      listTeamBoardImage: [], // 取得したスタンプマスタ
      colorCache: {}, // rgb色コード格納用
      currentScrollHeight: 0, // 現在の高さ取得用
      showReturnTopButtonHeight: 1000 // 画面TOPに戻るボタン表示開始位置
    }
  },
  computed: {
    campaign () {
      return this.$store.getters.getCampaign
    },
    isDisabledPostTeamComment () {
      return this.isPostLoading || (this.isStampMessageWindow && !this.post.image_id) || (!this.isStampMessageWindow && !this.post.comment)
    },
    listTeamUserWithoutCurrentUser () {
      return this.listTeamUser.filter((item) => item.id !== this.campaignUser.id)
    }
  },
  filters: {
    truncate: function (value) {
      if (value) {
        return value.substring(0, 2)
      }
    },
    formatDate: function (value) {
      if (value) {
        return dayjs.unix(value).format('MM/DD HH:mm')
      }
    }
  },
  async created () {
    await this.fetchListBoards(this.maxListTeamBoardSize)
    await this.fetchUserInfo()
    this.listTeamBoardImage = await getlistTeamBoardImage(this.campaign.id)
  },
  mounted () {
    // スクロール時の処理
    window.onscroll = () => {
      this.checkDispTopButton()
      this.infiniteScrolling()
    }
  },
  methods: {
    // ユーザー情報の取得
    async fetchUserInfo () {
      const currentCredentials = await Auth.currentCredentials()
      this.user.identityId = currentCredentials.identityId
      const currentUserInfo = await Auth.currentAuthenticatedUser()
      this.user.username = currentUserInfo.username
    },
    // チーム掲示板の取得
    async getListBoards (getListTeamBoardSize, nextToken) {
      try {
        const getListTeamBoardResult = await getListTeamBoard(this.campaign.id, this.teamId, getListTeamBoardSize, nextToken)
        if (nextToken) {
          this.listTeamBoard = this.listTeamBoard.concat(getListTeamBoardResult.listTeamBoard)
        } else {
          this.listTeamBoard = getListTeamBoardResult.listTeamBoard
        }
        this.next_token = getListTeamBoardResult.next_token
        this.isInitLoading = false
        this.isGetLoading = false
      } catch (e) {
        this.$emit('childErrorHandling', 'チーム掲示板の取得に失敗しました。' + e.errors[0].message)
        this.$log.debug(e)
        this.isInitLoading = false
        this.isGetLoading = false
      }
    },
    // 初期表示の件数を取得する
    async fetchListBoards (getListTeamBoardSize) {
      this.isInitLoading = true
      await this.getListBoards(getListTeamBoardSize)
    },
    // 新規投稿
    async postTeamComment () {
      this.isPostLoading = true
      try {
        this.post.post_type = this.isStampMessageWindow ? 'image' : 'comment'
        await putPostTeamComment(this.campaign.id, this.teamId, this.post)
        this.fetchListBoards(this.maxListTeamBoardSize)
        this.post = {}
        this.$refs.post_comment_form.reset()
      } catch (e) {
        this.$emit('childErrorHandling', 'コメントの投稿に失敗しました。' + e.errors[0].message)
        this.$log.debug(e)
      }
      this.dialog = false
      this.isPostLoading = false
    },
    // 投稿削除
    async deleteTeamComment (deletePost) {
      if (!await this.$refs.confirm.open(null, '削除してよろしいですか？')) {
        return
      }
      try {
        this.isDeleteLoading = true
        await putDeleteTeamComment(this.campaign.id, this.teamId, deletePost)
        this.fetchListBoards(this.listTeamBoard.length)
        this.isDeleteLoading = false
      } catch (e) {
        this.$emit('childErrorHandling', '削除に失敗しました。' + e.errors[0].message)
        this.$log.debug(e)
        this.isDeleteLoading = false
      }
    },
    // 無限スクロール処理
    infiniteScrolling () {
      const bottomOfWindow = window.pageYOffset + 1 >= document.body.clientHeight - window.innerHeight // 画面の一番下であることを確認
      if (bottomOfWindow && !this.isGetLoading && !this.isInitLoading && this.next_token) {
        this.isGetLoading = true
        window.setTimeout(() => {
          this.getListBoards(this.maxListTeamBoardSize, this.next_token)
        }, 1000)
      }
    },
    // 投稿者のユーザーIDから名前アイコンの色を生成する
    randomColor (id) {
      var num = Number(id.replace(/[^0-9]/g, '').slice(0, 4))
      const rgb = () => [(num * 13) % 256, (num * 17) % 256, (num * 19) % 256]
      return this.colorCache[id] || (this.colorCache[id] = `rgb(${rgb()[0]}, ${rgb()[1]}, ${rgb()[2]})`)
    },
    // 画面TOPに戻るボタンの表示処理
    checkDispTopButton () {
      this.currentScrollHeight = window.scrollY
      if (this.currentScrollHeight >= this.showReturnTopButtonHeight) {
        this.isDispTopButton = true
      } else {
        this.isDispTopButton = false
      }
    },
    // 画面TOPに戻るボタンの処理
    returnTop () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  }
}
</script>
<style scoped lang="scss">
.team-title {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

/* 投稿画面 */
.postCommentForm {
  max-height: 80%;
  max-width: 600px;
  .v-input--switch {
    display: inline-block;
  }
  .stampRadios {
    max-height: 350px;
  }
  .stampRadio {
    display:inline-block;
    img  {
      height: 80px;
      width: 80px;
      padding: 10px;
      margin: 10px;
      opacity: 0.3;
    }
    input[type=radio] {
      display: none;
    }
    input[type=radio]:checked+img  {
      opacity: 1;
      border: 1px solid #02AB98;
      border-radius: 20%;
    }
    @media (hover: hover) and (pointer: fine) {
      img:hover {
        opacity: 1;
      }
    }
  }
}

/* チーム掲示板一覧 */
.timeline {
  top: 0;
  bottom: 40px;
  margin: 0 auto;
  max-width: 900px;
  padding: 30px;
  background-color: #f5f5f5;
  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
              0px 2px 2px 0px rgb(0 0 0 / 14%),
              0px 1px 5px 0px rgb(0 0 0 / 12%) !important;
  border-radius: 20px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .boardThread {
    &.my {
      text-align: right;
      .avatar {
        float: right;
      }
      .avatarUserName {
        text-align: left;
        display: none;
      }
      .timeAndDeleteBtn {
        text-align: left;
      }
      .boardComment {
        color: white;
        background-color: #02AB98;
        text-align: left;
        &::before {
          right: 10px;
          top: -18px;
          transform: rotate(-90deg);
          border-left: 18px solid #02AB98;
        }
      }
      .boardImage {
        margin-right: 30px;
        height: 160px;
      }
    }
    &.other {
      text-align: left;
      .avatar {
        float: left;
      }
      .avatarUserName {
        text-align: left;
      }
      .timeAndDeleteBtn {
        text-align: left;
      }
      .boardComment {
        background-color: #FFFFFF;
        &::before {
          left: 10px;
          top: -18px;
          transform: rotate(90deg);
          border-right: 18px solid #FFFFFF;
        }
      }
      .boardImage {
        margin-left: 30px;
        height: 160px;
      }
    }
    .avatar {
      width: 60px;
      &::after {
        clear: both;
      }
      img {
        display: block;
        margin: 0 auto;
        width: 60px;
        height: 60px;
        border-radius: 50%;
        margin-bottom: 5px;
      }
    }
    .avatarUserName {
      width: 100%;
      font-size: 1.2rem;
      word-wrap: break-word;
    }
    .timeAndDeleteBtn {
      font-size: 1rem;
      color: gray;
      &::before {
        content: "\A" ;
        white-space: pre ;
      }
    }
    .boardComment {
      display: inline-block;
      position: relative;
      padding: 15px;
      margin-top: 20px;
      margin-bottom: 20px;
      border-radius: 20px;
      font-size: 1rem;
      word-wrap: break-word;
      &::before {
        content: '';
        position: absolute;
        border: 8px solid transparent;
      }
    }
    .boardImage {
      margin-top: 20px;
      margin-bottom: 20px;
    }
  }
}

.topButton {
  position: fixed;
  bottom: 50px;
  right: 24px;
  opacity: 0.6;
}
</style>
